import mergeDeep from 'lodash.merge';
import { jsonStringify } from '@ringcentral/rwc-utils/src/lang/json';

const LOGGER_KEY = 'rwcLoggerV2';

export class ConfigStorage {
    static LOGGER_KEY = LOGGER_KEY;

    constructor({ storage }) {
        const defaultStorage = globalThis.localStorage || null;
        this.storage = storage || defaultStorage;
    }

    /** Checks whether the stored config is empty or doesn't exist */
    isEmpty() {
        return Object.keys(this.getConfig()).length === 0;
    }

    /** Gets stored config */
    getConfig() {
        try {
            return JSON.parse(this.storage?.getItem(LOGGER_KEY) || '{}');
        } catch {
            return {};
        }
    }

    /** Updates stored config with the given changes */
    updateConfig(newConf) {
        if (!this.storage) return;

        const config = mergeDeep({}, this.getConfig(), newConf);
        this.storage.setItem(LOGGER_KEY, jsonStringify(config));
    }

    /** Updates stored config with the given transport config changes */
    updateTransportConfig(name, newConf) {
        if (!this.storage) return;

        const config = this.getConfig();
        config.transports = config.transports || {};
        config.transports[name] = { ...config.transports[name], ...newConf };
        this.storage.setItem(LOGGER_KEY, jsonStringify(config));
    }

    /** Clears stored config */
    clearConfig() {
        this.storage?.setItem(LOGGER_KEY, jsonStringify({}));
    }
}
